/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecentSearchQuery
 */
export interface RecentSearchQuery {
    /**
     * サジェスト順番
     * @type {number}
     * @memberof RecentSearchQuery
     */
    order: number;
    /**
     * サジェスト値
     * @type {string}
     * @memberof RecentSearchQuery
     */
    keyword: string;
}

export function RecentSearchQueryFromJSON(json: any): RecentSearchQuery {
    return RecentSearchQueryFromJSONTyped(json, false);
}

export function RecentSearchQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentSearchQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'order': json['order'],
        'keyword': json['keyword'],
    };
}

export function RecentSearchQueryToJSON(value?: RecentSearchQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order': value.order,
        'keyword': value.keyword,
    };
}

